import {
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";
import { motion } from "framer-motion";

const keywords = [
  {
    key: "<header>",
    type: "html",
  },
  {
    key: "<footer>",
    type: "html",
  },
  {
    key: "<main>",
    type: "html",
  },
  {
    key: "<nav>",
    type: "html",
  },
  {
    key: "<video>, zonder controls",
    type: "html",
  },
  {
    key: "<img>",
    type: "html",
  },
  {
    key: "<form>",
    type: "html",
  },
  {
    key: "<input type='text' />",
    type: "html",
  },
  {
    key: "<button>",
    type: "html",
  },
  {
    key: "grid - (3x3)",
    type: "css",
  },
  {
    key: "flex & flex-direction",
    type: "css",
  },
  {
    key: "text-align",
    type: "css",
  },
  {
    key: "max-width",
    type: "css",
  },
  {
    key: "margin / padding",
    type: "css",
  },
  {
    key: "border & border-radius",
    type: "css",
  },
  {
    key: "box-shadow",
    type: "css",
  },
  {
    key: ":hover",
    type: "css",
  },
  {
    key: "background",
    type: "css",
  },
  {
    key: ":active",
    type: "css",
  },
  {
    key: "opacity",
    type: "css",
  },
];

const AnimatedCard = motion(Card);

export const KdappontExamTraining = () => {
  return (
    <>
      <List>
        <ListItem>
          <Typography variant="h4">
            🚫 Gebruik vandaag géén AI. W3Schools e.d. is uiteraard wel
            toegestaan.
          </Typography>
        </ListItem>

        <ListItem>
          <Typography variant="h4">
            👷 Bouw een layout die gebruikt maakt van minstens de onderstaande
            "ingrediënten".
          </Typography>
        </ListItem>

        <ListItem>
          <Typography variant="h4">
            ⏱️ Toon op een willekeurige plek de huidige tijd. (AI is hiervoor
            wél toegestaan).
          </Typography>
        </ListItem>
      </List>

      <Divider />
      <Grid container size={12} spacing={2}>
        {keywords.map((keyword, index) => (
          <Grid size={3} key={index}>
            <AnimatedCard
              animate={{
                backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              sx={{
                textAlign: "center",
                background:
                  "linear-gradient(-45deg, #56ab2f, #a8e063, #56ab2f)",
                backgroundSize: "200% 200%",
                color: "white",
                p: 1,
                borderRadius: 2,
              }}
            >
              <CardHeader
                avatar={<Chip color="info" label={keyword.type} />}
              ></CardHeader>
              <CardContent>
                <Typography
                  sx={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)" }}
                  variant="h4"
                  component="div"
                  fontWeight="bold"
                  color="white"
                >
                  {keyword.key}
                </Typography>
              </CardContent>
            </AnimatedCard>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
